<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId" :key="key" @input="closeInput")
      button.button.success(slot="trigger", v-if="couponProp") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .column
          label Activation code
            input(type="text", v-model="body.code")
          label Valid from
            date-picker(v-model="body.start", :pickTime="true", :initial-date="body.start" format="yyyy-mm-dd hh:ii:ss" )
          label Valid to
            date-picker(v-model="body.end", :pickTime="true", :initial-date="body.end", format="yyyy-mm-dd hh:ii:ss")
        .column
          label Type
            select(v-model="type")
              option Fixed
              option Percentage
          template(v-if="type == 'Fixed'")
            label Common Cost
              selectize-common-cost(:selectedValue="body.common_cost_id", @optionSelected="setCommonCost")
            label Service
              select(v-model="body.service")
                option(:value="null") All
                option Reservation
                option Subscription
          template(v-else)
            label Discount percentage
              input(type="number", v-model="body.discount_rate")
          template(v-if="type == 'Fixed'")
            label Max days
              input(type="number" v-model="body.max_days")
          label Max uses
            input(type="number" v-model="body.max_uses")

          label Max uses per driver
            input(type="number" v-model="body.max_uses_per_driver")


      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import StartEndTimePicker from './StartEndTimePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import MaggieHelper from '../../maggieHelper'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeCommonCost from '../../components/structure/ui/lists/selectize/SelectizeCommonCost'

export default {
  name: 'CouponReveal',
  components: {SelectizeCommonCost, ActionButton, ModalReveal, StartEndTimePicker, DatePicker},
  data() {
    return {
      type: 'Fixed',
      body: {
        code: null,
        start: null,
        end: null,
        max_uses: null,
        max_uses_per_driver: null,
        max_days: null,
        common_cost_id: null,
        discount_rate: null
      },
      key:0
    }
  },
  created() {
    if (this.couponProp !== null) {
      this.type = this.couponProp.common_cost === null ? 'Percentage' : 'Fixed'
      for (let key in this.couponProp) {
        // console.log(key, this.couponProp[key])
        if (key === 'common_cost' && this.couponProp[key] !== null) {
          this.body.common_cost_id = this.couponProp.common_cost.id
        } else {
          this.body[key] = this.couponProp[key]
        }

      }
    }
  },
  methods: {
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    setCommonCost(obj) {
      this.body.common_cost_id = obj.id
    },
    save() {
      if (this.couponProp === null) {
        return KeplerBackofficeSdk.coupons.make(this.body, () => {
          MaggieHelper.notification('', 'coupon created')
          this.key++
          location.reload()
          this.$refs[this.componentId].close()

        })

      }
      if(this.body.discount_rate !== null && this.type ==='Percentage') {
        this.body.common_cost_id = null
      } else {
        this.body.discount_rate = null
      }

      return KeplerBackofficeSdk.coupons.select(this.couponProp.id).edit(this.body, (data) => {
        MaggieHelper.notification('', 'coupon updated')
        this.$emit('itemUpdated')
        this.$refs[this.componentId].close()
      })
    }
  },
  computed: {
    componentId() {
      return this.couponProp !== null ? `voidReveal-${this.couponProp.id}` : `voidReveal-${this._uid}`
    },

  },
  props: {
    couponProp: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CouponReveal.vue?aef87ad6